import { render } from "./HeroSideBarFooter.vue?vue&type=template&id=1f905863"
import script from "./HeroSideBarFooter.vue?vue&type=script&lang=js"
export * from "./HeroSideBarFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__